import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_urgency_message';
const urgencyMessageQuery = `
    query UnitMessage($unitUuid: String!, $dateRange: UrgencyDateRange,) {
        unitMessage(unitUuid: $unitUuid, dateRange: $dateRange) {
            iconTextV2 {
                message
                icon
            }
        }
    }
`;

async function urgencyMessageGraphQl({unitUuid, startDate, endDate, locale}) {
    let params = {unitUuid};

    if (startDate && endDate) {
        params.dateRange = {startDate, endDate};
    }

    const mutatedResponse = await graphqlQuery(OPERATION_NAME, urgencyMessageQuery, params, locale);

    return ((mutatedResponse || {}).unitMessage || {}).iconTextV2;
}

export default urgencyMessageGraphQl;
export {
    urgencyMessageGraphQl,
    OPERATION_NAME,
    urgencyMessageQuery
};
